import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper'
import { capitalizeFirstLetter } from './utils'
Swiper.use([ Autoplay, Pagination, EffectFade ])


export function sliderHeroInit() {
  $('.slider--hero').each(function() {
    let options = {
      effect: 'fade',
      speed: 800,
      autoplay: {
        delay: 8000,
      },
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
    }

    if($(this).data('pagination')) {
      options = {
        ...options,
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    }

    new Swiper(this, options)
  })
}

export function sliderContentInit() {
  $('.slider--content').each(function() {
    let options = {
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      breakpoints: {
        768: {
          spaceBetween: 40,
        },
      },
    }

    if($(this).data('pagination')) {
      options = {
        ...options,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    }

    new Swiper(this, options)
  })
}

export function sliderImagesInit() {
  $('.slider--images').each(function() {
    let options = {
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      breakpoints: {
        768: {
          spaceBetween: 36,
        },
      },
    }

    if($(this).data('pagination')) {
      options = {
        ...options,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    }

    new Swiper(this, options)
  })
}

export function sliderTabsInit() {
  $('.slider--tabs').each(function() {
    const tabs = ($(this).data('tabs') || []).split(',')

    let options = {
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      on: {
        init: function(swiper){
          updateDescription(tabs[swiper.activeIndex])
        },
        activeIndexChange: function(swiper){
          updateDescription(tabs[swiper.activeIndex])
        },
      },
      breakpoints: {
        768: {
          spaceBetween: 36,
        },
      },
    }

    if(tabs.length > 0){
      options = {
        ...options,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function(index, className){
            let title = tabs[index].replace(/-/g, ' ') || '';
            return '<span class="' + className + '">' + capitalizeFirstLetter(title) + '</span>'
          },
        },
      }
    }

    new Swiper(this, options)

    function updateDescription(title){
      $('[data-tabs-description]').removeClass('visible')
      $('[data-tabs-description=' + title + ']').addClass('visible')
    }
  })
}

export function sliderPostInit() {
  $('.slider--post').each(function() {
    let options = {
      slidesPerView: 'auto',
      spaceBetween: 24,
      grabCursor: true,
      breakpoints: {
        768: {
          spaceBetween: 36,
        },
      },
    }

    if($(this).data('pagination')) {
      options = {
        ...options,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    }

    new Swiper(this, options)
  })
}
